export const transformModifiersToUpdateInCategory = (
  initialItems = [],
  initialModifiersMappingMinMaxOrderCount,
  allItems = [],
  currentValueItems = [],
  currentCategoryUuid = '',
  modifiersMappingMinMaxOrderCount,
  displayCategoriesUuids
) => {
  // --- removed items calculations ---

  const deletedItems = initialItems.filter(
    (item) => !currentValueItems.includes(item)
  )

  // return already deleted items
  const itemsWithDeletedCategoryUuids = allItems.filter((item) =>
    deletedItems.includes(item.uuid)
  )

  // remove deleted item uuid from itemCategoryUuids
  const filteredCategoryUuidInDeletedItem =
    itemsWithDeletedCategoryUuids.reduce((result, item) => {
      const filteredUuid = item.itemCategoryUuids.filter((item) => {
        return item !== currentCategoryUuid
      })

      const itemWithFilteredCategoryUuid = {
        uuid: item?.uuid,
        itemCategoryExternalRefIds: item?.itemCategoryExternalRefIds,
        itemCategoryUuids: filteredUuid,
        // clear values of orderMinCount and orderMaxCount when delete categoryUuid
        orderMinCount: null,
        orderMaxCount: null,
      }

      return [...result, itemWithFilteredCategoryUuid]
    }, [])

  // --- added items calculations ---

  // return items to add
  const itemsWithCategoryUuidsToAdd = allItems.filter(
    (item) =>
      currentValueItems.includes(item.uuid) &&
      !item.itemCategoryUuids.includes(currentCategoryUuid)
  )

  // add item uuid to itemCategoryUuids
  const itemsWithAddedCategoryUuids =
    itemsWithCategoryUuidsToAdd.reduce((result, item) => {
      // when add item uuid to itemCategory, we have to fill in orderMinCount and
      // orderMaxCount, when user do not fill in this values, then we have to send null
      const { orderMinCount, orderMaxCount } =
        modifiersMappingMinMaxOrderCount?.find(
          ({ uuid }) => uuid === item.uuid
        )

      // itemCategoryUuids with new modifier uuid and
      // when we add modifier uuid to itemCategoryUuids we should remove all
      // display categories uuids included in itemCategoryUuids
      const updatedItemCategoryUuids = [
        ...item.itemCategoryUuids,
        currentCategoryUuid,
      ].filter((uuid) => !displayCategoriesUuids?.includes(uuid))

      const itemWithFilteredCategoryUuid = {
        uuid: item?.uuid,
        itemCategoryExternalRefIds: item?.itemCategoryExternalRefIds,
        itemCategoryUuids: updatedItemCategoryUuids,
        orderMinCount: orderMinCount !== '' ? orderMinCount : null,
        orderMaxCount: orderMaxCount !== '' ? orderMaxCount : null,
      }

      return [...result, itemWithFilteredCategoryUuid]
    }, [])

  // array of items where uuids were added to itemCategoryUuids or removed from itemCategoryUuids
  const itemsWithRemovedAndAddedUuidsToItemCategory = [
    ...filteredCategoryUuidInDeletedItem,
    ...itemsWithAddedCategoryUuids,
  ]

  // array of uuids from itemsWithRemovedAndAddedUuidsToItemCategory in order to filter them from updated items
  const itemsWithRemovedAndAddedUuids =
    itemsWithRemovedAndAddedUuidsToItemCategory?.map(
      ({ uuid }) => uuid
    )

  // --- updated items calculations ---

  // return array of modified orderMaxCount or orderMinCount values
  const updatedModifiersMappingMinMaxOrderCount =
    modifiersMappingMinMaxOrderCount?.filter((modifiedMinMax) => {
      // initial value of modifiedMinMax for each iteration
      const initialMinMax =
        initialModifiersMappingMinMaxOrderCount.find(
          ({ uuid }) => uuid === modifiedMinMax?.uuid
        )

      // return true if orderMaxCount or orderMinCount are different
      if (
        initialMinMax.orderMaxCount !==
          modifiedMinMax.orderMaxCount ||
        initialMinMax.orderMinCount !== modifiedMinMax.orderMinCount
      ) {
        return true
      } else {
        return false
      }
    })

  // minMaxOrderValues filtered from itemsWithRemovedAndAddedUuids in case of not duplicate updated, added, removed items
  const minMaxOrderValuesToUpdate =
    updatedModifiersMappingMinMaxOrderCount?.filter(
      ({ uuid }) => !itemsWithRemovedAndAddedUuids.includes(uuid)
    )

  // these are items in case where the checkbox was initially checked but the min or max value wasn't filled in, and then user has
  // just filled in the min or max number
  const itemsWithUpdatedCategoryUuids = allItems
    ?.filter((item) => {
      // uuids of items with updated min or max count
      const minMaxOrderValuesToUpdateUuids =
        minMaxOrderValuesToUpdate?.map(({ uuid }) => uuid)

      return minMaxOrderValuesToUpdateUuids?.includes(item.uuid)
    })
    .map((item) => {
      // updated values of orderMinCount and orderMaxCount for current item
      const { orderMinCount, orderMaxCount } =
        modifiersMappingMinMaxOrderCount.find(
          ({ uuid }) => uuid === item.uuid
        )

      // when we update items we should remove all
      // display categories uuids included in itemCategoryUuids
      const filteredItemCategoryUuids =
        item?.itemCategoryUuids?.filter(
          (uuid) => !displayCategoriesUuids?.includes(uuid)
        )

      return {
        uuid: item?.uuid,
        itemCategoryExternalRefIds: item?.itemCategoryExternalRefIds,
        itemCategoryUuids: filteredItemCategoryUuids,
        orderMinCount: orderMinCount !== '' ? orderMinCount : null,
        orderMaxCount: orderMaxCount !== '' ? orderMaxCount : null,
      }
    })

  return [
    ...itemsWithUpdatedCategoryUuids,
    ...itemsWithRemovedAndAddedUuidsToItemCategory,
  ]
}
